import React from "react";
import { AgentDetailFormFieldConfig } from "./agentDetailFormField.types";
import { AgentDetailFormInput } from "./components/agentDetailFormInput/agentDetailFormInput.index";
import styles from "./agentDetailFormField.module.css";

export interface AgentDetailFormFieldProps {
    config: AgentDetailFormFieldConfig;
    value: string | null;
    originalValue?: string | null;
    disabled?: boolean;
    addonField?: string | null;
    onChange?: (value: string | null) => void;
}

export const AgentDetailFormField = ({
    config,
    value,
    originalValue,
    disabled = true,
    addonField,
    onChange,
}: AgentDetailFormFieldProps) => {
    const { type, label, placeholder, options, loading, validate, filter } = config;
    const error = validate ? validate(value, originalValue) : null;

    return (
        <div className={styles.formField}>
            <div className={styles.label}>{label}</div>
            <div className={styles.value}>
                <AgentDetailFormInput
                    type={type}
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                    addonField={addonField}
                    options={options}
                    loading={loading}
                    filter={filter}
                    onChange={onChange ?? (() => undefined)}
                />
                {error && <div className={styles.error}>{error}</div>}
            </div>
        </div>
    );
};
